import React, { useReducer, useContext } from "react";
import { countryReducer as reducer } from "../reducers/countryReducer";
import { countryActions as actions } from "../actions/countryActions";

const initialValue = {
  countries: null,
};

const countryContext = React.createContext();

const CountryContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <countryContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </countryContext.Provider>
  );
};

export const useCountryContext = () => useContext(countryContext);
export default CountryContext;
